module.exports = __webpack_public_path__ + "static/campaign-banner-0c5ba0a2a1ccf8f0450f92f35f173ad7.png";